
  import CSVDownload from '@/components/common/download-csv'
  import Confirm from '@/components/confirm.vue'
  import MCodeForm from '@/components/mcode/form'
  import MCodeEditForm from '@/components/mcode/edit'

  export default {
    components: {
      'm-csv-btn': CSVDownload,
      'm-confirm': Confirm,
      'm-code-form': MCodeForm,
      'm-code-edit-form': MCodeEditForm
    },
    data () {
      return {
        form: {},
        menu: false,
        menu2: false,
        time: null,
        date: null,
        dateFormatted: null,
        dialog: false,
        dialog_edit: false,
        search: '',
        pagination: {},
        selectedItem: {},
        visited: false,
        marked: false,
        headers: [
          {
            text: 'ID',
            align: 'left',
            sortable: false,
            value: 'id'
          },
          { text: 'M-code', value: 'mcode' },
          { text: 'Name', value: 'name' },
          { text: 'Forfait', value: 'price_other' },
          { text: 'Forfait dialyse', value: 'price_dialyse' },
          { text: 'Forfait radio', value: 'price_radio' },
          { text: 'Forfait chemo', value: 'price_chemo' },
          { text: 'Action', value: 'action' }
        ],
        items: []
      }
    },
    methods: {
      onSave (data) {
        if (data.mcode) {
          this.sendForm(data);
          this.dialog = false;
        }
      },
      onClose () {
        this.dialog = false;
        this.dialog_edit = false;
        this.reset();
        console.log('close');
      },
      reset () {
        this.form = {};
      },
      onRefresh () {
        this.getData();
      },
      inValidItem (item) {
        return !(/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(item.email_address));
      },
      onUpdate (data) {
        console.log('save update carecenter: ' + this.selectedItem.id, data);
        this.updateForm(data);
        this.onClose();
      },
      sendForm (data) {
        // var app = this;
        this.$http
        .post('api/mcode', data)
        .then(response => {
          console.log('response data', response.data);
          // app.items = response.data;
          this.reset();
          this.getData();
        })
        .catch(function (error) {
          console.log('catch:', error);
        });
      },
      updateForm (data) {
        this.updateCarecenter(data);
      },
      updateCarecenter (data, cb) {
        // var app = this;
        var id = this.selectedItem.id;
        console.log('updateForm', data);
        this.$http
        .put('api/mcode/' + id, data)
        .then(response => {
          console.log('response data', response.data);
          // this.reset();
          if (cb) {
            cb();
          } else {
            this.getDataCenters();
          }
          // app.items = response.data;
        })
        .catch(function (error) {
          console.log('catch:', error);
        });
      },
      editItem (item) {
        this.reset();
        this.selectedItem = this.items.find(i => i === item);
        this.dialog_edit = true;
        console.log('edit', this.selectedItem.id);
      },
      deleteItem (item) {
        this.$refs.confirm.open('Delete', item.mcode + ' ' + item.name + ' ?').then((confirm) => {
          if (confirm) {
            this.$http
            .delete('api/mcode/' + item.id)
            .then(response => {
              console.log('mcode deleted', response.data);
              this.getData();
            })
            .catch(function (error) {
              console.log('catch:', error);
            });
          }
        });
      },
      getData () {
        var app = this;
        this.$http
        .get('api/mcode')
        .then(response => {
          console.log('data', response.data);
          app.items = response.data;
        })
        .catch(function (error) {
          console.log('catch:', error);
        });
      }
    },
    created () {
      this.getData();
    }
  }
